/**
 *
 * Custom Header
 *
 * Handling position of header block
 */

jQuery(document).ready(function () {
    let headerTop = jQuery('header.header').offset().top;
    
    if(jQuery('.itbl-countdown-section').length > 0){
        var countdownBlockHeight = jQuery('.itbl-countdown-section')[0].offsetHeight;

        if(window.innerWidth > 768) {
            jQuery(jQuery(".site-content section")[0]).css("height", "calc(100vh - " + countdownBlockHeight + "px)");
        }
        jQuery(jQuery(".site-content section")[0]).removeClass('itbl-u-mb-4');
        jQuery(jQuery('.itbl-countdown-section')[0]).addClass('itbl-u-mb-4');

        const $countdown = jQuery('.itbl-countdown-section');
        var firstBlockHeight = $countdown[0].offsetTop + $countdown[0].clientHeight;
    } else {
        var firstBlockHeight = jQuery(jQuery(".site-content section")[0]).height();
    }

    headerTop = firstBlockHeight;
    jQuery('header.header').css("top", firstBlockHeight + 'px');
    jQuery('header.header').removeClass('hide');
    let wasHeaderMoving = jQuery(window).scrollTop() > headerTop

    jQuery(document).on('scroll', function (e) {
        let scrollTop = jQuery(window).scrollTop();

        if (scrollTop > headerTop) {
            wasHeaderMoving = true;
            jQuery('header.header').addClass('header-moving');
        }
        else {
            var firstBlockHeight = jQuery(jQuery(".site-content section")[0]).height();

            if(jQuery('.itbl-countdown-section').length > 0){
                const $countdown = jQuery('.itbl-countdown-section');
                firstBlockHeight = $countdown[0].offsetTop + $countdown[0].clientHeight;
            }

            headerTop = firstBlockHeight;
            jQuery('header.header').removeClass('header-moving');
            jQuery('header.header').css("top", firstBlockHeight);
        }
    });

    setTimeout(function() {
        updateHeaderDistance();
    }, 1500);

    function updateHeaderDistance() {
        var firstBlockHeight = jQuery(jQuery(".site-content section")[0]).height();

        if(jQuery('.itbl-countdown-section').length > 0){
            var countdownBlockHeight = jQuery('.itbl-countdown-section')[0].offsetHeight;
            firstBlockHeight = firstBlockHeight + countdownBlockHeight;
        }

        jQuery('header.header').css("top", firstBlockHeight);
    }

    var isHome = document.getElementById('is-home').innerHTML;
    var currentSiteUrl = document.getElementById('current-site-url').innerHTML;
    jQuery("#main-nav a").click(function (href) {
        var scrollToAnchor = href.target.href.split('#');
        const wasHeaderMovingBeforeTheFirstScroll = wasHeaderMoving
        jQuery('html, body').animate({
            scrollTop: jQuery("#" + scrollToAnchor[1]).offset().top - 150
        },
        800,
        'swing',
        function () {
          if (!wasHeaderMovingBeforeTheFirstScroll) {
            const scrollTop = jQuery("#" + scrollToAnchor[1])
              .offset().top - 150
            jQuery('html, body').animate({ scrollTop })
          }
        });

        if ($(window).width() < 768) {
            jQuery(".mobile-menu-content-wrap").slideUp();
        }
    });

    jQuery(".mobile-menu-trigger img").click(function () {
        jQuery(".mobile-menu-content-wrap").slideDown();
    });

    jQuery(".mobile-menu-close-icon-wrap").click(function () {
        jQuery(".mobile-menu-content-wrap").slideUp();
    });


});
